//================== Config ======================
export const tab_color = [
        'teal', 
        'orange', 
        '#00cc00', 
        'purple', 
        'red', 
        'blue', 
        'maroon', 
        'green',
        'black',
    ]
export const niv_color = [
    'rgba(0, 11, 172, 0.47)',
    'rgba(54, 0, 174, 0.58)',
    'rgba(174, 82, 0, 0.58)',
    'rgba(0, 138, 48, 0.7)',
    'rgb(80,130,180)',
    'rgb(80,130,180)',
    'rgb(200,80,100)',
    'rgba(120, 150, 140, 1)',
    'rgba(120, 150, 140, 1)',
    'rgb(200,80,100)',
    'rgb(160,70,160)',
    'rgb(160,70,160)',
    'rgb(56,140,158)',
    'rgb(230,120,70)'
]
export const diff_color = ['teal', 'chocolate', 'purple']

export const title_college=['6e', '5e', '4e', '3e', '2de']
export const title_college_h1=['Sixième', 'Cinquième', 'Quatrième', 'Troisième', 'Seconde']
export const title_lycee=['Tronc commun 1re G', 'Spé 1re G', 'Voie technologique', 'Spé STI2D', 'Spé Term G', 'Maths complémentaires', 'Maths expertes', 'Pour la physique', 'Prépa']
export const title_lycee_h1=['Tronc commun de 1re G', 'Spé 1re G', 'Voie technologique', 'Spé STI2D', 'Spé Terminale G', 'Maths complémentaires', 'Maths expertes', 'physique', 'Prépa']
export const slug_lycee=['tronc-com-1reG', '1re-G', 'voie-technologique', 'spe-STI2D', 'term-G', 'maths-complementaires', 'maths-expertes', 'physique', 'prepa']

export function message_to_users (user={profil:'eleve'}) {
    const date = new Date();

    /**
     *      ===============================
     *      Annonce Comptes purgés
     *      ===============================
     */
    if (date.getMonth() + 1 === 8 && date.getDate() >= 15 && date.getDate() < 20 && user.profil === 'Professeur') {
        return  <div className="alert info fadeout10"><br/>
                  Cher.e collègue,<br/>
                  Les comptes "élève" ont été purgés.<br/>
                  Vous pouvez désormais créer vos classes et inscrire vos élèves pour cette nouvelle année !
                  <br/><br/>
                </div>
    }

    /**
     *      ===============================
     *      Annonce de la Purge Des Comptes
     *      ===============================
     */
    if (date.getMonth() + 1 === 8 && date.getDate() >= 4 && date.getDate() < 15 && user.profil === 'Professeur'){
        return  <div className="alert info fadeout20"><br/>
                    Cher.e collègue,<br/>
                    Une nouvelle année va commencer et les comptes "élève" vont bientôt être purgés.<br/>
                    Si vous souhaitez conserver vos élèves, merci de nous le signaler en cliquant <a href="../contact.php">ici</a>
                    <br/><br/>
                </div>
    }
    /**
     Rappel : la <b>traduction automatique des pages Web</b>, en particulier sur Smartphone, crée des dysfonctionnements dans la réalisation des devoirs. Veillez à bien la désactiver.
     */

    /**
     *      ============================================
     *      Annonce traduction automatique des pages Web
     *      ============================================
    if (date.getMonth() + 1 === 9  && date.getDate() <= 20){
        return  <div className="alert info fadeout10"><br/>
                    Cher.e utilisateur,<br/>
                    Nous vous rappelons que la <b>traduction automatique des pages Web</b>, en particulier sur Smartphone, crée des dysfonctionnements dans la réalisation des devoirs. <br/>
                    Veillez à bien la désactiver.
                    <br/><br/>
                </div>
    }
     */

    /**
     *      ============================================
     *                  Annonce diverse
     *      ============================================
     */
    /*if (date.getMonth() + 1 === 4  && date.getDate() >= 21){
        return  <div className="alert info fadeout10"><br/>
                    Les élèves peuvent maintenant informer leur professeur qu'ils n'ont pas compris une réponse, <br/>lorsqu'ils travaillent un devoir, en cliquant sur le bouton ❓ dédié.
                    <br/><br/>
                </div>
    }*/

    /**
     *      ===============================
     *      Annonce Automates => Automaths
     *      ===============================
     */
    /*if (date.getMonth() + 1 === 11 && date.getDate() >= 20 && date.getDate() <= 30){
        return  <div className="alert info fadeout10"><br/>
                    Cher utilisateur,<br/>
                    Si vous voyez écrit <input style={{backgroundColor:"rgb(186,218,69,0.4)", margin:"0"}} type="button" value="Automates" /> au lieu de <input style={{backgroundColor:"rgb(186,218,69,0.4)", margin:"0"}} type="button" value="Automaths" />, vérifiez que la traduction automatique des pages de votre navigateur est bien désactivée.<br/>
                    Cela évitera des problèmes de pages blanches dans les activités.<br/>
                    Pour cela, rendez-vous dans les paramètres de votre navigateur, partie traduction automatique des pages.
                    <br/><br/>
                </div>
    }*/

    //return ''
  }


//================== Fonctions ======================


export function pluriel (value, end = 's') {
    if (value > 1) {return end}
  }

export function color_note (note) {
    if (note >= 80) {return 'darkgreen'}
    if (note >= 60) {return 'green'}
    if (note >= 40) {return 'orange'}
    if (note >= 0) {return 'red'}
  }

export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
  }

export function affiche_param (tabParam, selectedParam, name, handleClick) {
    const tabClasses = Array.isArray(tabParam) ? tabParam : Object.keys(tabParam)
    return tabClasses.map((elt, k)=><span 
            key = {k} 
            className = {'btn_param' + (elt === selectedParam ? ' active' : '')} 
            name = {name} 
            onClick = {handleClick}
            style={{color:elt === '🅳' ? "steelblue" : '', fontWeight:elt === '🅳' ? "bold" : ''}}
            >{elt}</span>)
}


function disblurw(word) {
    const alphab = '0aze+1rty2u-io3pml4kj*h5gfd6sqw/7xc8v9bn';
    let rep = '';
    let cle = '';
    cle = word.slice(50, 52)
    rep = word.slice(52, word.length).split('').map(e=> alphab.includes(e) ? alphab[(alphab.indexOf(e)-cle+40)%40] : e)
    rep = rep.join('')
  return rep;
}

export function disblur(question) {
    //const alphab = '0aze1rty2uio3pml4kjh5gfd6sqw7xc8v9bn';
    //let rep = '';
    //let cle = '';
    //if(question.length === 5 && (question[4]+'').length > 50) {
    if(question.length === 5 && !Array.isArray(question[4])) {
        //cle = question[4].slice(50, 52)
        //rep = question[4].slice(52, question[4].length).split('').map(e=> alphab.includes(e) ? alphab[(alphab.indexOf(e)-cle+36)%36] : e)
        //question[4] = rep.join('')
        question[4] = disblurw(question[4]+'')
    }

    if(question.length === 5 && Array.isArray(question[4])) {
        let multi_champ = question[4].map(e => disblurw(e+''))
        question[4] = multi_champ
    }

    if(question.length === 4) {
        let radio = question[3].map(e => disblurw(e+''))
        question[3] = radio
    }
  return question;
}

export function clean (word) {
    return word.replaceAll('É', 'e')
    .replaceAll('é', 'e')
    .replaceAll('è', 'e')
    .replaceAll('ê', 'e')
    .replaceAll('ù', 'u')
    .replaceAll('à', 'a')
    .replaceAll('ç', 'c')
    .replaceAll(' ', '')
    .toLowerCase()
}

export function multi_search (needle, haystack) {
    if (needle.includes(' ')) {
      return needle.split(' ').some(elt => clean(haystack).includes(clean(elt)))
    }
    return clean(haystack).includes(clean(needle));
}

/*
    '2024-09-01_2024-11-15',
    '2024-11-16_2024-03-10',
    '2024-03-11_2024-06-30',
 */

export function IsInPeriod (date, period) {
    const j = date.slice(0,2)*1
    const m = date.slice(3,5)*1

    const start_month = period.slice(5,7)*1
    const start_day = period.slice(8,10)*1
    const end_month = period.slice(16,18)*1
    const end_day = period.slice(19,21)*1

    let result = (m >= start_month && m <= end_month) 
           && (j >= start_day && m == start_month || m != start_month)
           && (j <= end_day && m == end_month || m != end_month)
    if (start_month > end_month) {
        result = (m >= start_month || m <= end_month) 
           && (j >= start_day && m == start_month || m != start_month)
           && (j <= end_day && m == end_month || m != end_month)
    }

    return result
}
export function currentPeriod (tab_period) {
    const d = new Date()
    const j = d.getDate() < 10 ? '0'+d.getDate() : d.getDate()
    const m = d.getMonth()+1 < 10 ? '0'+(d.getMonth()+1) : d.getMonth()+1
    const donne_le = j+'/'+m
    let period = ''
    //console.log(donne_le+' dans période : '+tab_period[0], IsInPeriod(donne_le, tab_period[0])) 

    return tab_period.filter(period => IsInPeriod(donne_le, period))[0]
}

export function Fonctions () {

  return (
    <div>
    	Composant Fonctions
    </div>
  );
}